import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, NeutralColors, Stack, IconButton, Text, DefaultButton } from '@fluentui/react';
import { useBreakpoint, useHydration } from '@agoras/hooks';
import { useHeaderButtons } from './useHeaderButtons.esm.js';
import classNames$1 from './styles.esm.js';
import Tooltip from '../../../Tooltip/Tooltip.esm.js';
import { useContext, Fragment } from 'react';
import MoreButton from './MoreButton/MoreButton.esm.js';
import UserButtons from './UserButtons/UserButtons.esm.js';
import { useHeaderPanel } from '../../../../hooks/useHeaderPanel.esm.js';
import logger from '@agoras/logger';
import { headerContext } from '../../context.esm.js';
import { AppContext } from '../../../context/context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    root: {
        height: 'inherit'
    },
    iconCounter: {
        alignSelf: 'flex-start',
        marginTop: 8
    }
});
var iconButtonStyles = {
    rootDisabled: {
        backgroundColor: 'unset'
    },
    rootHovered: {
        color: NeutralColors.gray160
    },
    root: {
        width: 'auto'
    }
};
var buttonStyles = {
    root: {
        backgroundColor: NeutralColors.gray30,
        border: 'none'
    },
    rootHovered: {
        backgroundColor: NeutralColors.gray40
    },
    rootChecked: {
        backgroundColor: NeutralColors.gray40
    },
    rootCheckedHovered: {
        backgroundColor: NeutralColors.gray40
    }
};
var TopHeaderButtons = function() {
    var _useHeaderButtons = _sliced_to_array(useHeaderButtons({
        excludeKeys: [
            'user'
        ]
    }), 1), headerButtons = _useHeaderButtons[0];
    var _useContext = useContext(AppContext), signedIn = _useContext.user.signedIn;
    var setOpenPanelKey = useHeaderPanel().setOpenPanelKey;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xxl', 'xxxl'), 1), isXXLAndHigher = _useBreakpoint[0];
    var _useBreakpoint1 = _sliced_to_array(useBreakpoint('xl'), 1), isXL = _useBreakpoint1[0];
    var isHydrated = useHydration();
    return /*#__PURE__*/ jsxs(Stack, {
        horizontal: true,
        horizontalAlign: "space-between",
        verticalAlign: "center",
        className: classNames.root,
        tokens: {
            childrenGap: signedIn ? 8 : 16
        },
        children: [
            isXXLAndHigher && /*#__PURE__*/ jsx(Stack, {
                horizontal: true,
                className: classNames.root,
                tokens: {
                    childrenGap: 8
                },
                verticalAlign: "center",
                children: headerButtons.sort(function(a, b) {
                    return Number(a.iconButton) - Number(b.iconButton);
                }).reverse().map(function(param) {
                    var key = param.key, ariaLabel = param.ariaLabel, iconName = param.iconName, disabled = param.disabled, href = param.href, onClick = param.onClick, relatedPanel = param.relatedPanel, tooltip = param.tooltip, text = param.text, onRenderText = param.onRenderText, iconCounter = param.iconCounter, _param_iconButton = param.iconButton, iconButton = _param_iconButton === void 0 ? true : _param_iconButton;
                    return /*#__PURE__*/ jsx(Fragment, {
                        children: iconButton ? /*#__PURE__*/ jsx(Tooltip, {
                            tooltipHostProps: {
                                content: tooltip,
                                styles: {
                                    root: {
                                        height: '100%'
                                    },
                                    content: {
                                        cursor: 'default'
                                    }
                                }
                            },
                            children: /*#__PURE__*/ jsx(IconButton, {
                                iconProps: {
                                    iconName: iconName
                                },
                                ariaLabel: ariaLabel,
                                disabled: !isHydrated || disabled,
                                onClick: function() {
                                    logger.info(JSON.stringify({
                                        key: key
                                    }), _object_spread({
                                        action: 'Navbar',
                                        actionModifier: 'Click'
                                    }, headerContext));
                                    if (relatedPanel) {
                                        setOpenPanelKey(key);
                                    }
                                    onClick === null || onClick === void 0 ? void 0 : onClick();
                                },
                                className: classNames$1.iconButton,
                                styles: iconButtonStyles,
                                href: href,
                                onRenderMenuIcon: iconCounter ? function() {
                                    return /*#__PURE__*/ jsx(Text, {
                                        className: classNames.iconCounter,
                                        children: iconCounter > 99 ? '99+' : iconCounter
                                    });
                                } : undefined
                            })
                        }) : /*#__PURE__*/ jsx(Tooltip, {
                            tooltipHostProps: {
                                content: tooltip,
                                styles: {
                                    root: {
                                        height: 'auto'
                                    },
                                    content: {
                                        cursor: 'default'
                                    }
                                }
                            },
                            children: /*#__PURE__*/ jsx(DefaultButton, {
                                iconProps: {
                                    iconName: iconName
                                },
                                styles: buttonStyles,
                                text: !onRenderText ? text : undefined,
                                ariaLabel: ariaLabel,
                                disabled: !isHydrated || disabled,
                                onClick: function() {
                                    logger.info(JSON.stringify({
                                        key: key
                                    }), _object_spread({
                                        action: 'Navbar',
                                        actionModifier: 'Click'
                                    }, headerContext));
                                    if (relatedPanel) {
                                        setOpenPanelKey(key);
                                    }
                                    onClick === null || onClick === void 0 ? void 0 : onClick();
                                },
                                children: !!onRenderText && /*#__PURE__*/ jsx(Stack, {
                                    verticalAlign: "center",
                                    horizontal: true,
                                    styles: {
                                        root: {
                                            marginLeft: 4
                                        }
                                    },
                                    children: onRenderText()
                                })
                            })
                        })
                    }, key);
                })
            }),
            isXL && /*#__PURE__*/ jsx(MoreButton, {}),
            /*#__PURE__*/ jsx(UserButtons, {})
        ]
    });
};

export { TopHeaderButtons as default };
